import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

// Deliberately does not reuse the shared `PersistedDataFrameGraphQL` fragment (which hardcodes
// `dataFrameJson(limitOffsetInput: {offset: $offset, limit: $limit}, ...)`) — this query only needs
// `dataFrameJson`'s row content; `name`/`columns`/`hydratedProperties` etc. don't vary by row window and
// are already known from whichever page the caller currently has loaded.
export const GET_PERSISTED_DATA_FRAME_ROWS_BY_ID_QUERY = gql`
  query GetPersistedDataFrameRowsById(
    $dataFrameId: StrictString!
    $rowIds: [StrictString!]!
    $sortInput: DataFrameSortInput
  ) @skipAudit @engComponent(name: DATA_FRAMES) {
    dataFrame(id: $dataFrameId) {
      ...InaccessibleInfoGraphQL
      ... on DataFrameNode {
        id
        dataFrameJson(rowIds: $rowIds, sortInput: $sortInput)
      }
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
